import React, { useState, useEffect } from "react";
import s from "./EditorPositionDirection.less";
import { getFormatDate } from "~/libs/getFormatDate";
import { useTranslation } from "react-i18next";

const EditPositionDirection = ({ object1, object2 }) => {
  const [differences, setDifferences] = useState({});

  const { t } = useTranslation();

  const areValuesEqual = (value1, value2) => {
    return value1 === value2;
  };

  const renderDifference = (oldValue, newValue) => {
    if (areValuesEqual(oldValue, newValue)) {
      return oldValue;
    } else {
      return (
        <span>
          <span className={s.redText}>{oldValue}</span>
          <span className={s.greenText}> → </span>
          <span className={s.greenText}>{newValue}</span>
        </span>
      );
    }
  };

  const formatStatusField = (key, obj1, obj2) => {
    const oldValue = t(`k.${obj1[key]}`);
    const newValue = t(`k.${obj2[key]}`);
    return areValuesEqual(oldValue, newValue)
      ? oldValue
      : `${oldValue} → ${newValue}`;
  };

  const processField = (key, obj1, obj2) => {
    switch (key) {
      case "ActualFrom":
      case "ActualTo":
      case "__typename":
        return null;
      case "createdAt":
      case "updatedAt":
        const oldDate = getFormatDate(obj1[key]);
        const newDate = getFormatDate(obj2[key]);
        return renderDifference(oldDate, newDate);
      case "statusEditPositionDirection":
        return formatStatusField(key, obj1, obj2);
      case "roleEditPositionDirection":
        const oldPositions = obj1[key]
          .map((position) => t(`k.${position}`))
          .join(", ");
        const newPositions = obj2[key]
          .map((position) => t(`k.${position}`))
          .join(", ");
        return renderDifference(oldPositions, newPositions);
      default:
        const oldValue = obj1[key];
        const newValue = obj2[key];
        return renderDifference(oldValue, newValue);
    }
  };

  useEffect(() => {
    const diff = {};
    for (const key in object1) {
      const fieldDiff = processField(key, object1, object2);
      if (fieldDiff) {
        diff[key] = fieldDiff;
      }
    }
    setDifferences(diff);
  }, [object1, object2]);

  return (
    <div>
      <ul>
        {Object.keys(differences).map((key, index) => (
          <li key={index}>
            <b className={s.difference_key}>{t(`k.${key}`)} </b>
            <span className={s.difference_value}> {differences[key]}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EditPositionDirection;
